import axios from "../plugins/axios";
import { ElMessage } from "element-plus";

/**
 * 洗车套餐管理列表
 * @param params
 * @returns {Promise<Awaited<{}>>}
 */
export const apiTimeConfigList = async (params) => {
    const res = await axios("/hardware/timeConfig/list", { params });
    if (res.data.code === 200) {
        return Promise.resolve(res.data.data || {});
    }
};

/**
 * 修改
 * @param params
 * @returns {Promise<Awaited<unknown>>}
 */
export const apiTimeConfigUpdate = async (params) => {
    const res = await axios.post("/hardware/timeConfig/update", params);
    if (res.data.code === 200) {
        ElMessage.success(res.data.msg);
        return Promise.resolve(res.data.id);
    } else {
        ElMessage.error(res.data.msg);
        return Promise.reject(res.data.msg);
    }
};

/**
 * 修改
 * @param params
 * @returns {Promise<Awaited<unknown>>}
 */
export const apiTimeConfigInstall = async (params) => {
    const res = await axios.post("/hardware/timeConfig/install", params);
    if (res.data.code === 200) {
        ElMessage.success(res.data.msg);
        return Promise.resolve(res.data.id);
    } else {
        ElMessage.error(res.data.msg);
        return Promise.reject(res.data.msg);
    }
};

/**
 * 修改
 * @param params
 * @returns {Promise<Awaited<unknown>>}
 */
export const apiTimeConfigDelete = async (params) => {
    const res = await axios.post("/hardware/timeConfig/delete", params);
    if (res.data.code === 200) {
        ElMessage.success(res.data.msg);
        return Promise.resolve(res.data.id);
    } else {
        ElMessage.error(res.data.msg);
        return Promise.reject(res.data.msg);
    }
};
